import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { NotifierService } from 'angular-notifier';
import * as XLSX from "xlsx";
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { AppAttributesService } from 'src/app/services/app-attributes.service';
import { Station } from 'src/app/models/station';
import { ReservationService } from 'src/app/services/reservation.service';
import { ArService } from './../../services/ar.service';
@Component({
  selector: 'app-ar-reports',
  templateUrl: './ar-reports.component.html',
  styleUrls: ['./ar-reports.component.scss']
})
export class ArReportsComponent implements OnInit {


  filters_form: FormGroup;
 // filters_form1: FormGroup;
  private notifier: NotifierService;
  agedStatusReport;
  transactionReport;
  searchText;
 // searchText1;
  stations;
  contractIds:any;
  stationsList: Station[];
  customerList: any[];
  AllStationsCodes = [];
  payrollReport = [];

  reservationStatusList = [
    {
      resStatusId: "A",
      resCustText: "Concierge Assigned",
      resBoText: "Assigned"
    },
    {
      resStatusId: "C",
      resCustText: "Completed Service",
      resBoText: "Completed"
    },
    {
      resStatusId: "I",
      resCustText: "Greet In Process",
      resBoText: "In Progress"
    }
  ];

  billingStatusList = [
    {
      resStatusId: "CP",
      resCustText: "Complete",
      resBoText: "Assigned"
    },
    {
      resStatusId: "CPNR",
      resCustText: "Completed Service",
      resBoText: "Needs Review"
    },
    {
      resStatusId: "UFSNR",
      resCustText: "Completed Service",
      resBoText: "Unfulfilled Service"
    }
  ];

  fromDate = moment().startOf("day").subtract(7, "days").format('MM/DD/YYYY HH:mm');
  toDate = moment().endOf("day").format('MM/DD/YYYY HH:mm');
  yesNoOptions = [
    { label: 'Capital one', value: true },
  ];
  constructor(private spinner: NgxSpinnerService, private formBuilder: FormBuilder, notifier: NotifierService,
    private authService: AuthenticationService,
    private employeeService: EmployeeService,
    private appAttrService: AppAttributesService,
    public dasboardService : DashboardService,
    public reservationService : ReservationService,
              public arService: ArService
  ) {
    this.initForm();
   // this.initForm1()
  }

    ngOnInit() {
    this.getCustomers();
    this.getStations();
    this.fromDate = moment().startOf('year').startOf('day').format('MM/DD/YYYY HH:mm');
    this.toDate = moment().endOf('year').endOf('day').format('MM/DD/YYYY HH:mm');
    this.getAgedStatusReport();
    this.getTransactionReportBySearch(
        this.fromDate,
        this.toDate,
        [],
        '',
        '')
    this.uniqueContractIds()

  }

  async getAgedStatusReport() {
    this.spinner.show();
    await this.dasboardService.getAgedStatusReport().subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.agedStatusReport = res['result'];
        // console.log(this.agedStatusReport);
      }
    })
  }

  async getTransactionReportBySearch(startDate, endDate,promoServices, stationCode, customerCompanyName, isCapitalOne = []) {
    // console.log(promoServices);
    
    this.spinner.show();
    await this.dasboardService.getTransactionReportBySearch(
        startDate,
        endDate,
        promoServices,
        stationCode,
        customerCompanyName,
        isCapitalOne
    ).subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.transactionReport = res['result'];
        // console.log(this.transactionReport);
      }
    })
  }



  getDate(date) {
    return moment.utc(date).format('MMM DD, YYYY');
  }

  initForm() {
    this.filters_form = this.formBuilder.group({
      resType: new FormControl(''),
      stationcodes: new FormControl(''),
      resStatus: new FormControl(''),
      startdate: new FormControl(this.fromDate),
      enddate: new FormControl(this.toDate),
      promoservices : new FormControl([]),
      stationCode: new FormControl(''),
      customerCompanyName: new FormControl(''),
      isCapitalOne: new FormControl([])
    })
  }

  // initForm1() {
  //   this.filters_form1 = this.formBuilder.group({
  //     startdate1: new FormControl(this.fromDate),
  //     enddate1: new FormControl(this.toDate),
  //   })
  // }

  // onFilter1(values) {
  //   if (values.startdate1 == '' && values.enddate1 == '') {
  //     this.notifier.notify('warning', 'Please enter date');
  //     return;
  //   }
  //   if (values.startdatee1 == '' || values.startdate1 == null || values.startdate1 == 'Invalid date') {
  //     this.notifier.notify('warning', 'Please enter from date');
  //     return;
  //   }
  //   if (values.enddate1 == '' || values.enddate1 == null || values.enddate1 == 'Invalid date') {
  //     values.enddate = moment().format("MM/DD/YYYY HH:mm")
  //   }
  //   if (moment(values.startdate1).isAfter(moment(values.enddate1))) {
  //     this.notifier.notify('warning', 'From date must be less then to date');
  //     return;
  //   }
  //   this.getAgedStatusReport(moment(values.startdate).startOf("day").format('MM/DD/YYYY HH:mm'),   moment(values.enddate).endOf("day").format('MM/DD/YYYY HH:mm'));
  // }

  onFilter(values) {
    // console.log(values);
    
    if (values.startdate == '' && values.enddate == '') {
      this.notifier.notify('warning', 'Please enter date');
      return;
    }
    if (values.startdatee == '' || values.startdate == null || values.startdate == 'Invalid date') {
      this.notifier.notify('warning', 'Please enter from date');
      return;
    }
    if (values.enddate == '' || values.enddate == null || values.enddate == 'Invalid date') {
      values.enddate = moment().format("MM/DD/YYYY HH:mm")
    }
    if (moment(values.startdate).isAfter(moment(values.enddate))) {
      this.notifier.notify('warning', 'From date must be less then to date');
      return;
    }

    this.getTransactionReportBySearch(
        moment(values.startdate).startOf("day").format('MM/DD/YYYY HH:mm'),
        moment(values.enddate).endOf("day").format('MM/DD/YYYY HH:mm') ,
        values.promoservices,
        values.stationCode,
        values.customerCompanyName,
        values.isCapitalOne,
        );
   
  }

  isShow: boolean = false;

  // showFilter1() {
  //   this.isShow = !this.isShow;
  // }

  showFilter() {
    this.isShow = !this.isShow;
  }

  // onReset1() {
  //   this.initForm1();
  //   this.isShow = false
  //   this.searchText1 = ''
  //  // this.getData();
  // }

  onReset() {
    this.initForm();
    this.isShow = false
    this.searchText = ''
    let values = this.filters_form.value
    this.getTransactionReportBySearch(
        moment(values.startdate).startOf("day").format('MM/DD/YYYY HH:mm'),
        moment(values.enddate).endOf("day").format('MM/DD/YYYY HH:mm') ,
        values.promoservices,
        values.stationCode,
        values.customerCompanyName,
        values.isCapitalOne
    );
   // this.getData();
  }
  onRefresh() {
    this.initForm();
    this.isShow = false
    this.searchText = ''
    let values = this.filters_form.value
    this.getTransactionReportBySearch(
        moment(values.startdate).startOf("day").format('MM/DD/YYYY HH:mm'),
        moment(values.enddate).endOf("day").format('MM/DD/YYYY HH:mm') ,
        values.promoservices,
        values.stationCode,
        values.customerCompanyName,
        values.isCapitalOne
    );
  }

  exportExcel() {

    const transformedReport = this.transactionReport.map(item => {
      const { is_capital_one, RESID ,...rest } = item;
      return {
        RESID,
        "Promotional Contract": is_capital_one ? 'Capital One' : '',
        ...rest,
      };
    });

    const workSheet = XLSX.utils.json_to_sheet(transformedReport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'Report');
    let timeSpan = new Date().toISOString();
    let prefix = "Report";
    let fileName = `${prefix}-${timeSpan}.xlsx`;
    XLSX.writeFile(workBook, fileName);
  }

  exportToExcel() {
    TableUtil.exportToExcel("report25con");
  }
  uniqueContractIds(){
    this.reservationService.getcontractIds().subscribe(contractIds => {
      this.contractIds = contractIds['result'];
    })
   }
  getStations() {
    this.arService.getAllstationsWithCode().subscribe((stationData) => {
      this.stationsList = stationData['result']
    })
  }
  getCustomers() {
    this.arService.getCustomers().subscribe((customersData) => {
      this.customerList = customersData['result']
    })
  }
}





export class TableUtil {
  static exportToExcel(tableId: string, name?: string) {
    let timeSpan = new Date().toISOString();
    let prefix = name || "ExportResult";
    let fileName = `${prefix}-${timeSpan}`;
    let targetTableElm = document.getElementById(tableId);
    let wb = XLSX.utils.table_to_book(targetTableElm, <XLSX.Table2SheetOpts>{ sheet: prefix });
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }
}

















//   agedStatusReport = []
//   fromDate;
//   toDate;
//   constructor(public dasboardService : DashboardService, private spinner: NgxSpinnerService,) { }

//   ngOnInit() {

//     this.fromDate = moment().startOf('year').startOf('day').format('MM/DD/YYYY HH:mm');
//     this.toDate = moment().endOf('year').endOf('day').format('MM/DD/YYYY HH:mm');
//     this.getAgedStatusReport();
//     this.getTransactionReportBySearch(this.fromDate,  this.toDate)

//   }
//   async getAgedStatusReport() {
//     this.spinner.show();
//     await this.dasboardService.getAgedStatusReport().subscribe(res => {
//       if (res['status']) {
//         this.agedStatusReport = res['result'];
//         console.log(this.agedStatusReport);
//       }
//     })
//   }

//   async getTransactionReportBySearch(startDate, endDate) {
//     this.spinner.show();
//     await this.dasboardService.getTransactionReportBySearch(startDate, endDate).subscribe(res => {
//       if (res['status']) {
//         this.agedStatusReport = res['result'];
//         console.log(this.agedStatusReport);
//       }
//     })
//   }

// }
